import React, { useRef, useCallback } from 'react';
import './Hero.css';
import BG1 from '../assets/BG1.png';
import logo2 from '../assets/logo2.png';
import { projectMedia } from '../utils/sharedMedia';

const heroVideo = projectMedia('videos', 'HorrorMovieHouse.mp4');

function Hero() {
  const videoRef = useRef(null);

  const handleTimeUpdate = useCallback(() => {
    const vid = videoRef.current;
    if (vid && vid.duration - vid.currentTime <= 3) {
      vid.currentTime = 0;
    }
  }, []);

  return (
    <section className="hero">
      <video
        ref={videoRef}
        className="hero-video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster={BG1}
        onTimeUpdate={handleTimeUpdate}
      >
        <source src={heroVideo} type="video/mp4" />
      </video>
      <div className="hero-overlay"></div>
      <img src={logo2} alt="Studio 13 Logo" className="hero-logo" />
    </section>
  );
}

export default Hero;
